export const SkiaViewNativeId = { current: 1000 };
